import script from "./new-property-wizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-property-wizard.vue?vue&type=script&setup=true&lang=ts"

import "./new-property-wizard.vue?vue&type=style&index=0&id=5570145e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5570145e"]])

export default __exports__